import { render, staticRenderFns } from "./HistoryDashboard.vue?vue&type=template&id=af515d60"
import script from "./HistoryDashboard.vue?vue&type=script&lang=js"
export * from "./HistoryDashboard.vue?vue&type=script&lang=js"
import style0 from "./HistoryDashboard.vue?vue&type=style&index=0&id=af515d60&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports